import React from "react";

const GENDER_OPTIONS = ["Male", "Female", "Other"];

const OtherServiceForm = ({
  formData,
  setFormData,
  countryCodeOptions,
  profileView,
  serviceSubTypes,
  serviceSubTypesLoading,
  toggleGender,
  toggleSubtype
}) => (
  <>
    <h2 className="sp-section-title">Service Configuration</h2>
    <div className="sp-grid">
      <label className="sp-field">
        <span>Provider Primary Country Code</span>
        <select
          value={formData.providerPrimaryCountryCode}
          onChange={(event) =>
            setFormData((prev) => ({
              ...prev,
              providerPrimaryCountryCode: event.target.value
            }))
          }
          disabled={formData.useUserProfileNumberAsWorkNumber}
        >
          {countryCodeOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </label>

      <label className="sp-field">
        <span>Provider Primary Phone Number</span>
        <input
          type="text"
          value={formData.providerPrimaryPhoneNumber}
          onChange={(event) =>
            setFormData((prev) => ({
              ...prev,
              providerPrimaryPhoneNumber: event.target.value
            }))
          }
          disabled={formData.useUserProfileNumberAsWorkNumber}
        />
      </label>

      <label className="sp-field sp-checkbox sp-full">
        <input
          type="checkbox"
          checked={formData.useUserProfileNumberAsWorkNumber}
          onChange={(event) => {
            const checked = event.target.checked;
            setFormData((prev) => ({
              ...prev,
              useUserProfileNumberAsWorkNumber: checked,
              providerPrimaryCountryCode: checked
                ? profileView.primaryPhoneCountryCode || prev.providerPrimaryCountryCode
                : prev.providerPrimaryCountryCode,
              providerPrimaryPhoneNumber: checked
                ? profileView.primaryPhoneNumber || ""
                : prev.providerPrimaryPhoneNumber
            }));
          }}
        />
        <span>Use my user profile mobile number as work number</span>
      </label>

      <label className="sp-field">
        <span>Provider Secondary Country Code</span>
        <select
          value={formData.providerSecondaryCountryCode}
          onChange={(event) =>
            setFormData((prev) => ({
              ...prev,
              providerSecondaryCountryCode: event.target.value
            }))
          }
        >
          {countryCodeOptions.map((option) => (
            <option key={`secondary-${option.value}`} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
      </label>

      <label className="sp-field">
        <span>Provider Secondary Phone Number</span>
        <input
          type="text"
          value={formData.providerSecondaryPhoneNumber}
          onChange={(event) =>
            setFormData((prev) => ({
              ...prev,
              providerSecondaryPhoneNumber: event.target.value
            }))
          }
        />
      </label>

      <div className="sp-field sp-full">
        <span>Gender To Service *</span>
        <div className="sp-multi-options">
          {GENDER_OPTIONS.map((option) => (
            <label key={option}>
              <input
                type="checkbox"
                checked={formData.genderToService.includes(option)}
                onChange={() => toggleGender(option)}
              />
              <span>{option}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="sp-field sp-full">
        <span>Service Sub Types *</span>
        <div className="sp-multi-options">
          {serviceSubTypes.map((item) => (
            <label key={item.id}>
              <input
                type="checkbox"
                checked={formData.selectedSubTypes.includes(item.name)}
                onChange={() => toggleSubtype(item.name)}
              />
              <span>{item.name}</span>
            </label>
          ))}
          {!serviceSubTypesLoading && serviceSubTypes.length === 0 && (
            <p>No sub types found for selected service.</p>
          )}
          {serviceSubTypesLoading && <p>Loading sub types...</p>}
        </div>
      </div>

      <label className="sp-field">
        <span>Experience (years) *</span>
        <input
          type="number"
          min="0"
          value={formData.yearOfExperience}
          onChange={(event) => setFormData((prev) => ({ ...prev, yearOfExperience: event.target.value }))}
        />
      </label>

      <label className="sp-field">
        <span>Available From</span>
        <input
          type="time"
          value={formData.availableFrom}
          onChange={(event) => setFormData((prev) => ({ ...prev, availableFrom: event.target.value }))}
        />
      </label>

      <label className="sp-field">
        <span>Available Till</span>
        <input
          type="time"
          value={formData.availableTill}
          onChange={(event) => setFormData((prev) => ({ ...prev, availableTill: event.target.value }))}
        />
      </label>

      <label className="sp-field sp-checkbox">
        <input
          type="checkbox"
          checked={formData.servesNight}
          onChange={(event) => setFormData((prev) => ({ ...prev, servesNight: event.target.checked }))}
        />
        <span>Also serves at night</span>
      </label>
    </div>
  </>
);

export default OtherServiceForm;
